<div class="landing_page">
  @if (loginDisplay) {
  <div class="container">
    <p>landing page</p>
  </div>
  } @else {
  <div class="card h-screen w-full">
    <div class="container">
      <p class="title">
        Authenticate your account by logging into Deloitte's SSO Provider
      </p>
    </div>
    <p-button (click)="login()" label="Login"></p-button>
  </div>
  }
</div>
